import { clearFromLocalStorage, retrieveFromLocalStorage, saveToLocalStorage } from './util';

const SESSION_KEY = 'userSession';
const MAX_SESSION_DURATION = 1000 * 60 * 60 * 10;

export const startSession = () => {
  const timeStamp = Date.now();
  const sessionData = { maxDuration: timeStamp + MAX_SESSION_DURATION };
  saveToLocalStorage(SESSION_KEY, sessionData);
};

export const endSession = () => {
  clearFromLocalStorage(SESSION_KEY);
};

export const checkSession = () => {
  try {
    const sessionData = retrieveFromLocalStorage(SESSION_KEY);
    if (sessionData) {
      const maxDuration = sessionData.maxDuration;
      const currentTime = Date.now();

      if (currentTime > maxDuration) {
        endSession();
        return false;
      }
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};
